import {
  getSelectDropdownListFloatingConfig,
  SELECT_DROPDOWN_LIST_MAX_HEIGHT_ENTITY,
} from '../../Select'

export const CURRENCY_SELECT_DROPDOWN_FLOATING_CONFIG =
  getSelectDropdownListFloatingConfig(SELECT_DROPDOWN_LIST_MAX_HEIGHT_ENTITY)

export const CURRENCY_SELECT_DECIMAL_SEPARATOR = ','

export const CURRENCY_SELECT_GROUPING_SEPARATOR = '.'

export const CURRENCY_SELECT_MAX_FRACTION_DIGITS = 2

export const CURRENCY_SELECT_INTEGER_FORMAT_OPTIONS = {
  maximumFractionDigits: 0,
}

// A "significant" character carries value: a digit or the decimal separator.
// Grouping dots (and anything else) are cosmetic and never shift the caret.
export const CURRENCY_SELECT_SIGNIFICANT_CHARACTER = /[\d,]/
